import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import { Analytics } from '@vercel/analytics/react';
import TournamentForm from './components/TournamentForm';
import PlayerSetup from './components/PlayerSetup';
import Tournament from './components/Tournament';
import Results from './components/Results';
import { LanguageProvider } from './contexts/LanguageContext';
import ErrorBoundary from './components/ErrorBoundary';
import TvMode from './components/TvMode';
import Privacy from './components/Privacy';
import { ThemeModeProvider } from './contexts/ThemeModeContext';

function App() {
  return (
    <ErrorBoundary>
      <Analytics />
      <LanguageProvider>
        <ThemeModeProvider>
        <Container
          maxWidth={false}
          disableGutters
          sx={{ 
            minHeight: '100vh',
            backgroundColor: 'background.default',
            overflow: 'hidden'
          }}
        >
          <BrowserRouter>
            <Box sx={{
              width: '100%',
              maxWidth: 960,
              mx: 'auto',
              mt: 0,
              px: { xs: 1, sm: 2 },
              pt: { xs: 0, sm: 1 },
              pb: { xs: 2, sm: 3 },
              boxSizing: 'border-box'
            }}>
              <Routes>
                <Route path="/" element={<Navigate to="/new" replace />} />
                <Route path="/new" element={<TournamentForm />} />
                <Route path="/tournament/:name/setup" element={<PlayerSetup />} />
                <Route path="/tournament/:name" element={<Tournament />} />
                <Route path="/tournament/:name/tv" element={<TvMode />} />
                <Route path="/tv/:firebaseId" element={<TvMode />} />
                <Route path="/results/:name" element={<Results />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="*" element={<Navigate to="/new" replace />} />
              </Routes>
          </Box>
        </BrowserRouter>
        <Box sx={{
          textAlign: 'center',
          py: 2,
            color: 'text.secondary',
            fontSize: '0.875rem'
          }}>
            © {new Date().getFullYear()} Vamos Tamos by{' '}
            <Box
              component="a"
              href="https://www.linkedin.com/in/adnand/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' }
              }}
            >
              Adnan Dervisevic
            </Box>
            {' | '}
            <Box
              component="a"
              href="https://www.instagram.com/vamostamos.app/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' }
              }}
            >
              Instagram
            </Box>
            {' | '}
            <Box
              component="a"
              href="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' }
              }}
            >
              Privacy Policy
          </Box>
        </Box>
      </Container>
        </ThemeModeProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
